/* kjp-custombulk.js — custom-kit builder <-> bulk enquiry page (12-Oct-2026, STAGING first; go-live re-applies)
   1. Quote modal: "Quote the matching kit too" — optional checkboxes for the other garments (same design, colours,
      logo, roster). Quantities default to the current size/roster total (editable). Quote-only: no prices shown.
      The /quote spec gets "Matching kit: Shorts, Hoodie" + a quantities line right after "Product: <garment>",
      and front/back JPEG snapshots of each matching garment (viewer switched to that garment, snapped, switched back;
      works with the viewer offscreen). Total attachments stay <= 8 (shopper files + design + roster first);
      snapshots that don't fit are named in the spec as not attached.
   2. (Removed 12-Oct: the bulk page is now for catalogue products only, so the builder no longer links or hands its
      design to it. designLink() stays: it keys the snapshot cache. Custom kits are quoted from this modal.)
   Talks to kjp.js only through window.KJP_API, to kjp-features.js through window.KJP_QUOTE_EXTRAS (wrapped), and to
   the viewer through .setProduct / .snap / ._debug().shown. Any failure = the quote goes exactly as before. */
(function () {
  'use strict';
  var MAX_ATT = 8, IMG_MAX_BYTES = 600 * 1024, LINK_MAX = 3500;
  var ORDER = ['jersey', 'shorts', 'pants', 'hoodie', 'tracksuit'];
  var LABEL = { jersey: 'Jersey', shorts: 'Shorts', pants: 'Long Pants', hoodie: 'Hoodie', tracksuit: 'Tracksuit' };

  function api() { return window.KJP_API || null; }
  function viewer() { var a = api(); var v = a && a.cfg ? a.cfg() : null; return v && v.snap && v.setProduct ? v : null; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, txt) { var e = document.createElement(tag); cls && (e.className = cls); txt != null && (e.textContent = txt); return e; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function frame() { return new Promise(function (r) { var d = false, f = function () { d || (d = true, r()); }; requestAnimationFrame(f); setTimeout(f, 60); }); }
  function totalQty() { var a = api(), s = a && a.S && a.S.sizes || {}; return Object.keys(s).reduce(function (t, k) { return t + (+s[k] || 0); }, 0); }
  function curProduct() { var a = api(); return a && a.S && a.S.product || 'jersey'; }
  function dataUrlToBlob(d) {
    var i = d.indexOf(','), b = atob(d.slice(i + 1)), n = b.length, u = new Uint8Array(n);
    while (n--) u[n] = b.charCodeAt(n);
    return new Blob([u], { type: (/:(.*?);/.exec(d.slice(0, i)) || [])[1] || 'image/jpeg' });
  }
  function toFile(blob, name) { try { return new File([blob], name, { type: blob.type }); } catch (e) { blob.name = name; return blob; } }
  function jpeg(c) {
    for (var q = 0.86; q > 0.3; q -= 0.12) {
      var d = c.toDataURL('image/jpeg', q);
      if (Math.floor((d.length - d.indexOf(',') - 1) * 3 / 4) <= IMG_MAX_BYTES) return d;
    }
    return null;
  }

  /* ─────────────── design link (shared with the bulk page) ─────────────── */
  function designLink() {
    var a = api(); if (!a || !a.link) return null;
    var url = a.link();
    if (url.length <= LINK_MAX) return url;
    try { /* drop the roster from an over-long link; keep everything else */
      var m = url.match(/#d=([A-Za-z0-9+/]+)$/); if (!m) return null;
      var d = JSON.parse(decodeURIComponent(escape(atob(m[1])))); delete d.r;
      url = url.slice(0, m.index) + '#d=' + btoa(unescape(encodeURIComponent(JSON.stringify(d)))).replace(/=+$/, '');
      return url.length <= LINK_MAX ? url : null;
    } catch (e) { return null; }
  }

  /* ─────────────── 1. matching kit in the quote modal ─────────────── */
  var box = null, stEl = null, cache = {}, busy = Promise.resolve(), pending = 0;

  function css() {
    if ($('#kjp-mk-css')) return;
    var s = el('style'); s.id = 'kjp-mk-css';
    s.textContent =
      '.kjp-mk{margin:0 0 16px;padding:12px 14px;border:1px solid var(--kjp-border,#E4E0F0);border-radius:10px;background:var(--kjp-surface-2,#F8F6FD);min-width:0}' +
      '.kjp-mk legend{float:left;width:100%;padding:0;margin:0 0 2px;font-size:13px;font-weight:700;color:var(--kjp-text,#0F0A1E)}' +
      '.kjp-mk legend span{font-weight:500;color:var(--kjp-muted,#67627C)}' +
      '.kjp-mk__hint{clear:both;margin:0 0 8px;font-size:12px;line-height:1.4;color:var(--kjp-muted,#67627C)}' +
      '.kjp-mk__row{display:flex;align-items:center;justify-content:space-between;gap:10px;min-height:40px;border-top:1px solid var(--kjp-border,#E4E0F0)}' +
      '.kjp-mk__row:first-of-type{border-top:0}' +
      '.kjp-mk__row label{display:flex;align-items:center;gap:9px;flex:1;min-height:40px;font-size:14px;font-weight:600;color:var(--kjp-text-2,#3B3552);cursor:pointer}' +
      '.kjp-mk__row input[type=checkbox]{width:18px;height:18px;margin:0;accent-color:var(--kjp-violet,#7C3AED)}' +
      '.kjp-mk__q{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--kjp-muted,#67627C)}' +
      '.kjp-mk__q input{width:68px;min-height:34px;padding:4px 8px;border:1.5px solid var(--kjp-border,#E4E0F0);border-radius:8px;background:#fff;font:inherit;font-size:16px;color:var(--kjp-text,#0F0A1E);text-align:right}' +
      '.kjp-mk__q input:disabled{opacity:.45;background:transparent}' +
      '.kjp-mk__q input:focus{outline:none;border-color:var(--kjp-violet,#7C3AED);box-shadow:0 0 0 3px rgba(124,58,237,.18)}' +
      '.kjp-mk__st{margin:6px 0 0;font-size:12px;font-weight:600;color:var(--kjp-violet-dk,#5B21B6);min-height:0}' +
      '.kjp-mk__st:empty{display:none}' +
      '.kjp-mk__imgs{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0 0}.kjp-mk__imgs:empty{display:none}' +
      '.kjp-mk__imgs img{width:40px;height:46px;object-fit:cover;border-radius:6px;border:1px solid var(--kjp-border,#E4E0F0);background:#F4F2FA}';
    document.head.appendChild(s);
  }

  function build() {
    if (box) return box;
    var anchor = $('[data-kjp-qprev]'); if (!anchor) return null;
    css();
    box = el('fieldset', 'kjp-mk'); box.setAttribute('data-kjp-mk', '');
    var lg = el('legend'); lg.appendChild(document.createTextNode('Quote the matching kit too ')); lg.appendChild(el('span', null, '(optional)'));
    box.appendChild(lg);
    box.appendChild(el('p', 'kjp-mk__hint', 'Same design, colours, logo and roster. Priced in the same quote.'));
    ORDER.forEach(function (g) {
      var row = el('div', 'kjp-mk__row'); row.setAttribute('data-kjp-mk-row', g);
      var lb = el('label'), cb = el('input'); cb.type = 'checkbox'; cb.value = g; cb.setAttribute('data-kjp-mk-cb', g);
      lb.appendChild(cb); lb.appendChild(document.createTextNode(LABEL[g]));
      var q = el('span', 'kjp-mk__q'), qi = el('input');
      qi.type = 'number'; qi.inputMode = 'numeric'; qi.min = '1'; qi.max = '5000'; qi.step = '1'; qi.disabled = true;
      qi.setAttribute('data-kjp-mk-qty', g); qi.setAttribute('aria-label', LABEL[g] + ' quantity (pieces)');
      q.appendChild(qi); q.appendChild(document.createTextNode('pcs'));
      row.appendChild(lb); row.appendChild(q); box.appendChild(row);
      cb.addEventListener('change', function () {
        qi.disabled = !cb.checked;
        if (cb.checked) { qi.value || (qi.value = totalQty()); queue(g); }
        thumbs();
      });
      qi.addEventListener('input', function () { qi.dataset.kjpEdited = '1'; });
    });
    stEl = el('p', 'kjp-mk__st'); stEl.setAttribute('aria-live', 'polite'); box.appendChild(stEl);
    box.appendChild(el('div', 'kjp-mk__imgs'));
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    return box;
  }

  function chosen() {
    if (!box) return [];
    var cur = curProduct();
    return $$('[data-kjp-mk-cb]', box).filter(function (c) { return c.checked && c.value !== cur; }).map(function (c) { return c.value; });
  }
  function qtyOf(g) {
    var i = box && $('[data-kjp-mk-qty="' + g + '"]', box), n = i ? Math.floor(+i.value) : 0;
    return n > 0 ? Math.min(n, 5000) : totalQty();
  }

  /* called each time the quote modal opens */
  function onOpen() {
    if (!build()) return;
    var cur = curProduct(), t = totalQty();
    $$('[data-kjp-mk-row]', box).forEach(function (row) {
      var g = row.getAttribute('data-kjp-mk-row'), cb = $('input[type=checkbox]', row), qi = $('[data-kjp-mk-qty]', row);
      row.hidden = g === cur;
      if (g === cur) cb.checked = false;
      qi.disabled = !cb.checked;
      if (!qi.dataset.kjpEdited) qi.value = t;
    });
    var key = designLink();
    Object.keys(cache).forEach(function (k) { cache[k].key !== key && delete cache[k]; });
    chosen().forEach(queue);
    thumbs();
  }

  function thumbs() {
    if (!box) return;
    var wrap = $('.kjp-mk__imgs', box); wrap.replaceChildren();
    chosen().forEach(function (g) {
      var c = cache[g]; if (!c || !c.shots) return;
      c.shots.forEach(function (s) { var im = el('img'); im.src = s.url; im.alt = LABEL[g] + ' preview, ' + s.view; im.width = 40; im.height = 46; wrap.appendChild(im); });
    });
    if (!pending) stEl.textContent = chosen().length ? 'Matching kit previews will be attached.' : '';
  }

  function waitShown(v, g, ms) {
    var t0 = Date.now();
    return new Promise(function (res) {
      (function poll() {
        var sh = null; try { sh = v._debug ? v._debug().shown : g; } catch (e) {}
        if (sh === g) return res(true);
        if (Date.now() - t0 > ms) return res(false);
        setTimeout(poll, 120);
      })();
    });
  }

  /* switch the viewer (not the builder state) to g, snap front + back, switch back */
  function snapGarment(g) {
    var v = viewer(), key = designLink();
    if (!v) return Promise.resolve(null);
    var a = api(), S = a && a.S, lp = S && S.logoPos;
    return (async function () {
      try {
        if (g === 'tracksuit' && lp === 'center' && v.setLogoPos) v.setLogoPos('left'); /* jacket: no centre logo under the zip */
        v.setProduct(g);
        if (!(await waitShown(v, g, 15000))) return null;
        await frame(); await frame();
        var shots = [];
        ['front', 'back'].forEach(function (view) {
          var c = v.snap(view, 900, '#F4F2FA'), d = c && jpeg(c);
          d && shots.push({ view: view, url: d, file: toFile(dataUrlToBlob(d), 'kibi-matching-' + g + '-' + view + '.jpg') });
        });
        return shots.length ? { key: key, shots: shots } : null;
      } catch (e) { return null; }
      finally {
        try {
          var now = curProduct();
          v.setProduct(now);
          if (g === 'tracksuit' && lp === 'center' && v.setLogoPos && now !== 'tracksuit') v.setLogoPos(S.logoPos);
          await waitShown(v, now, 15000);
        } catch (e2) {}
      }
    })();
  }

  function queue(g) {
    var key = designLink();
    if (cache[g] && cache[g].key === key) return busy;
    pending++;
    stEl && (stEl.textContent = 'Preparing ' + LABEL[g] + ' preview…');
    busy = busy.then(function () { return snapGarment(g); }).then(function (r) {
      r ? (cache[g] = r) : (cache[g] = { key: key, shots: null, failed: true });
    }).catch(function () {}).then(function () { pending--; thumbs(); });
    return busy;
  }

  /* hold the submit until queued snapshots are ready (max 20 s), then re-submit */
  var released = false;
  function initSubmitHold() {
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.matches || !f.matches('[data-kjp-quote-form]')) return;
      if (released || !pending) { released = false; return; }
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = f.querySelector('[type=submit]'), was = btn && btn.innerHTML;
      btn && (btn.disabled = true, btn.textContent = 'Preparing previews…');
      Promise.race([busy, wait(20000)]).then(function () {
        btn && (btn.disabled = false, btn.innerHTML = was);
        released = true;
        f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }, true);
  }

  function wrapExtras() {
    var orig = window.KJP_QUOTE_EXTRAS;
    window.KJP_QUOTE_EXTRAS = function (fd, used) {
      var n = 0;
      try { n = orig ? (orig(fd, used) || 0) : 0; } catch (e) {}
      try {
        var gs = chosen(); if (!gs.length) return n;
        var body = String(fd.get('contact[body]') || ''), lines = body.split('\n');
        var at = -1; for (var i = 0; i < Math.min(lines.length, 6); i++) if (/^Product:/.test(lines[i])) { at = i; break; }
        var mk = ['Matching kit: ' + gs.map(function (g) { return LABEL[g]; }).join(', '),
          'Matching kit quantities: ' + gs.map(function (g) { return LABEL[g] + ' ' + qtyOf(g) + ' pcs'; }).join(' | ') +
          ' (same design, colours, logo and roster; quote only)'];
        lines.splice(at >= 0 ? at + 1 : lines.length, 0, mk[0], mk[1]);
        /* fronts first, then backs, within the 8-file limit */
        var room = Math.max(0, MAX_ATT - (used || 0) - n), files = [], skipped = [], fails = [];
        ['front', 'back'].forEach(function (view) {
          gs.forEach(function (g) {
            var c = cache[g];
            if (!c || !c.shots) { view === 'front' && fails.push(LABEL[g]); return; }
            c.shots.forEach(function (s) {
              if (s.view !== view) return;
              files.length < room ? files.push(s.file) : skipped.push(LABEL[g] + ' ' + view);
            });
          });
        });
        var idx = (used || 0) + n;
        files.forEach(function (f, j) { fd.append('contact[attachment_' + (idx + j + 1) + ']', f, f.name); });
        files.length && lines.push('Matching kit previews attached: ' + files.map(function (f) { return f.name; }).join(', '));
        skipped.length && lines.push('Matching kit previews not attached (8-file limit): ' + skipped.join(', '));
        fails.length && lines.push('Matching kit previews unavailable: ' + fails.join(', '));
        fd.set('contact[body]', lines.join('\n'));
        return n + files.length;
      } catch (e) { return n; }
    };
  }

  function init() {
    var root = $('[data-kjp]'); if (!root) return;
    wrapExtras();
    initSubmitHold();
    var qb = $('[data-kjp-quote-btn]', root), ov = $('[data-kjp-overlay]');
    /* kjp.js opens the modal on this click (bound earlier); kjp-features.js snaps the current garment at t=0 */
    qb && qb.addEventListener('click', function () { setTimeout(function () { ov && ov.classList.contains('open') && onOpen(); }, 30); });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  window.KJP_CUSTOMBULK = { designLink: designLink, chosen: chosen, cache: cache };
})();
